// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app/" + (chunkId === 5302 ? "vizels" : chunkId) + "." + __webpack_require__.h().slice(0, 4) + ".js";
};